import { ReactElement, Suspense } from 'react';
import { Spin } from 'antd';
import PageLayout from '../../../components/PageLayout';
import MainContent from '../../../components/MainContent';
import SideBar from '../../../components/SideBar';
import Header from './components/Header';
import Content from './components/Content';

const RecordingDetailPage = (): ReactElement => (
  <PageLayout
    sidebar={<SideBar />}
    mainContent={
      <MainContent
        header={
          <Suspense fallback={<Spin />}>
            <Header />
          </Suspense>
        }
        content={
          <Suspense fallback={<Spin />}>
            <Content />
          </Suspense>
        }
      />
    }
  />
);

export default RecordingDetailPage;
